import { memo } from 'react';

import { useLanguagePreference } from '@/hooks/useLanguagePreference';

// ============================================================================
// Flag Icon Components
// ============================================================================

const VietnamFlag = memo(function VietnamFlag() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="14"
        cy="14"
        r="13"
        fill="#DA251D"
      />
      <path
        d="M14 7L15.75 12.25H21L16.625 15.75L18.375 21L14 17.5L9.625 21L11.375 15.75L7 12.25H12.25L14 7Z"
        fill="#FFCD00"
      />
    </svg>
  );
});

const UKFlag = memo(function UKFlag() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="14"
        cy="14"
        r="13"
        fill="#012169"
      />
      <path
        d="M3.5 5.5L14 14M14 14L24.5 5.5M14 14L3.5 22.5M14 14L24.5 22.5"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M14 1.5V26.5M1.5 14H26.5"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M14 1.5V26.5M1.5 14H26.5"
        stroke="#C8102E"
        strokeWidth="2.5"
      />
    </svg>
  );
});

// ============================================================================
// Main Component
// ============================================================================

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { currentLanguage, updateLanguage } = useLanguagePreference();
  const isVietnamese =
    currentLanguage === 'vi' || currentLanguage?.startsWith('vi');

  const handleToggle = () => {
    updateLanguage(isVietnamese ? 'en' : 'vi');
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`hover:bg-primary/10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full transition-colors ${className || ''}`}
      title={isVietnamese ? 'Switch to English' : 'Chuyển sang Tiếng Việt'}
    >
      {isVietnamese ? <VietnamFlag /> : <UKFlag />}
    </button>
  );
}
